export const ABORT = 'abort';
export const CRASH = 'Crash';
